module.exports = __webpack_public_path__ + "img/seat.5e431de0.svg";